/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AlertCondition } from './AlertCondition';
import {
    AlertConditionFromJSON,
    AlertConditionFromJSONTyped,
    AlertConditionToJSON,
} from './AlertCondition';

/**
 * 
 * @export
 * @interface AlertRuleResponse
 */
export interface AlertRuleResponse {
    /**
     * 
     * @type {string}
     * @memberof AlertRuleResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleResponse
     */
    machineId?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleResponse
     */
    machinePartId?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleResponse
     */
    sectionType?: AlertRuleResponseSectionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleResponse
     */
    questionMatch?: string;
    /**
     * 
     * @type {AlertCondition}
     * @memberof AlertRuleResponse
     */
    condition?: AlertCondition;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleResponse
     */
    severity?: AlertRuleResponseSeverityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleResponse
     */
    active?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertRuleResponse
     */
    notifyRoles?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof AlertRuleResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AlertRuleResponse
     */
    updatedAt?: Date;
}


/**
 * @export
 */
export const AlertRuleResponseSectionTypeEnum = {
    StatusCheck: 'STATUS_CHECK',
    NumberEntry: 'NUMBER_ENTRY',
    TextResult: 'TEXT_RESULT'
} as const;
export type AlertRuleResponseSectionTypeEnum = typeof AlertRuleResponseSectionTypeEnum[keyof typeof AlertRuleResponseSectionTypeEnum];

/**
 * @export
 */
export const AlertRuleResponseSeverityEnum = {
    Info: 'INFO',
    Warning: 'WARNING',
    Critical: 'CRITICAL'
} as const;
export type AlertRuleResponseSeverityEnum = typeof AlertRuleResponseSeverityEnum[keyof typeof AlertRuleResponseSeverityEnum];


/**
 * Check if a given object implements the AlertRuleResponse interface.
 */
export function instanceOfAlertRuleResponse(value: object): value is AlertRuleResponse {
    return true;
}

export function AlertRuleResponseFromJSON(json: any): AlertRuleResponse {
    return AlertRuleResponseFromJSONTyped(json, false);
}

export function AlertRuleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertRuleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'machinePartId': json['machinePartId'] == null ? undefined : json['machinePartId'],
        'sectionType': json['sectionType'] == null ? undefined : json['sectionType'],
        'questionMatch': json['questionMatch'] == null ? undefined : json['questionMatch'],
        'condition': json['condition'] == null ? undefined : AlertConditionFromJSON(json['condition']),
        'severity': json['severity'] == null ? undefined : json['severity'],
        'active': json['active'] == null ? undefined : json['active'],
        'notifyRoles': json['notifyRoles'] == null ? undefined : json['notifyRoles'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function AlertRuleResponseToJSON(value?: AlertRuleResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'machineId': value['machineId'],
        'machinePartId': value['machinePartId'],
        'sectionType': value['sectionType'],
        'questionMatch': value['questionMatch'],
        'condition': AlertConditionToJSON(value['condition']),
        'severity': value['severity'],
        'active': value['active'],
        'notifyRoles': value['notifyRoles'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

